import { CloneStoryMeta, CloneStoryPayload } from 'types/store/CloneStory';
import { createAsyncReducer } from 'utils/Redux';

import { cloneStoryActions } from '../actions';

export default createAsyncReducer<CloneStoryMeta, CloneStoryPayload>(cloneStoryActions);
